!function () {
  'use strict';

  if (customElements.get('youtube-video')) return;

  customElements.define('youtube-video', class extends HTMLElement {
    connectedCallback() {
      this.poster = this.querySelector('[data-youtube-poster]');
      this.videoId = this.dataset.videoId;

      if (!this.poster || !this.videoId) return;

      this.onPosterClick = this.onPosterClick.bind(this);
      this.poster.addEventListener('click', this.onPosterClick);
    }

    disconnectedCallback() {
      if (this.poster) this.poster.removeEventListener('click', this.onPosterClick);
    }

    onPosterClick(evt) {
      evt.preventDefault();
      this.loadIframe();
    }

    loadIframe() {
      if (this.iframe) return;

      const params = new URLSearchParams({
        autoplay: '1',
        playsinline: '1',
        rel: '0',
        modestbranding: '1'
      });

      if (this.dataset.muted === 'true') params.set('mute', '1');

      if (this.dataset.loop === 'true') {
        params.set('loop', '1');
        params.set('playlist', this.videoId);
      }

      this.iframe = document.createElement('iframe');
      this.iframe.className = 'youtube-video__frame';
      this.iframe.src = `https://www.youtube.com/embed/${this.videoId}?${params.toString()}`;
      this.iframe.title = this.dataset.videoTitle || '';
      this.iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      this.iframe.setAttribute('allowfullscreen', '');
      this.iframe.setAttribute('frameborder', '0');

      this.poster.replaceWith(this.iframe);
      this.classList.add('is-playing');
    }
  });
}();
